import React, { Component } from 'react';
import { Table } from 'react-bootstrap';
import { Link, withRouter } from 'react-router-dom';
import Moment from 'moment';
import { translate } from 'react-i18next';
import Dialog from 'react-bootstrap-dialog';

import TooltipLink from './TooltipLink';
import TooltipButton from './TooltipButton';

import './OrganisationTable.css';

class OrganisationTable extends Component {
    constructor(props) {
        super(props);

        const childProps = this.props.childProps;

        this.state = {
            currentOrganisation: childProps.currentOrganisation,
            changeOrganisation: childProps.changeOrganisation
        };
    }

    didConfirmDelete(organisation) {

        const password = this.deleteOrganisationPassword.value;
        const token = this.deleteOrganisation2FAToken.value;

        this.props.onDeleteOrganisation(organisation, password, token);
    }

    didConfirmDeactivate(organisation) {
        this.props.onDeactivate(organisation);
    }

   handleDeleteClicked = (organisation) => {
    const self = this;

    class NameConfirmBody extends React.Component {
            state = { input: '' };

            render() {
                const match = this.state.input === organisation.name;
                return (
                    <div>
                        <div style={{ background: '#f8d7da', color: '#721c24', border: '1px solid #f5c6cb', padding: 16, borderRadius: 4, marginBottom: 16 }}>
                            <strong>Warning:</strong> This action is <b>permanent</b> and cannot be undone.<br />
                            To confirm deletion, please type <b>{organisation.name}</b> below.<br />
                            Make sure all Media is deleted before proceeding.
                        </div>
                        <input
                            type="text"
                            className="form-control"
                            placeholder={`Type "${organisation.name}" to confirm`}
                            value={this.state.input}
                            onChange={e => this.setState({ input: e.target.value })}
                            style={{ marginBottom: 16 }}
                        />
                        <div style={{ textAlign: 'right' }}>
                            <button
                                className="btn btn-default"
                                onClick={() => self.dialog.hide()}
                                style={{ marginRight: 8 }}
                            >
                                {self.props.t('Dialog.cancel')}
                            </button>
                            <button
                                className="btn btn-danger"
                                disabled={!match}
                                onClick={() => {
                                    self.dialog.hide();
                                    self.showPasswordDialog(organisation);
                                }}
                            >
                                {self.props.t('Dialog.continue')}
                            </button>
                        </div>
                    </div>
                );
            }
        }

        this.dialog.show({
            title: this.props.t('Dialog.deleteOrganisation'),
            body: <NameConfirmBody t={this.props.t} />,
            actions: [], // No footer actions, handled in body
            bsSize: 'large',
            onHide: dialog => dialog.hide()
        });
    };

    showPasswordDialog = (organisation) => {
        this.dialog.show({
            title: this.props.t('Dialog.deleteOrganisation'),
            body: (
                <div>
                    <div className="form-group">
                        <label>{this.props.t('Dialog.password')}</label>
                        <input
                            type="password"
                            ref={(input) => { this.deleteOrganisationPassword = input; }}
                            className="form-control"
                            placeholder={this.props.t('Dialog.enterPassword')}
                        />
                    </div>
                    <div className="form-group">
                        <label>{this.props.t('Dialog.token')}</label>
                        <input
                            type="text"
                            ref={(input) => { this.deleteOrganisation2FAToken = input; }}
                            className="form-control"
                            placeholder={this.props.t('Dialog.enterToken')}
                        />
                    </div>
                </div>
            ),
            actions: [
                Dialog.Action(
                    this.props.t('Dialog.cancel'),
                    () => this.dialog.hide(),
                    'btn-default'
                ),
                Dialog.Action(
                    this.props.t('Dialog.delete'),
                    () => this.didConfirmDelete(organisation),
                    'btn-danger'
                )
            ],
            bsSize: 'large',
            onHide: dialog => dialog.hide()
        });
    };

    handleDeactivateClicked(organisation) {
        const { t } = this.props;

        const listedOrganisation = (
			<li>
				<strong>{organisation.name}</strong>
			</li>
		);

		this.dialog.show({
			title: t('Dialog.warning'),
			body: (
				<div>
					{t('Dialog.sure_deactivate')}
					{listedOrganisation}
				</div>
			),
            actions: [
                Dialog.Action(
                    t('Dialog.cancel'),
                    () => console.log('Cancel!'),
                    'btn-default'
                ),
                Dialog.Action(
                    t('Dialog.deactivate'),
                    () => this.didConfirmDeactivate(organisation),
                    'btn-danger'
                )
            ],
            bsSize: 'large',
            onHide: dialog => {
                dialog.hide();
            }
        });
    }

    handleChangeOrganisation(organisation) {
        this.state.changeOrganisation(organisation);
        this.props.history.push(`/organisations/${organisation.uuid}`);
    }

    isFavourited(organisation) {
        const { favouriteOrganisations } = this.props;
        if (!favouriteOrganisations) return false;
        return favouriteOrganisations.some(fav => fav.uuid === organisation.uuid);
    }

    handleStarClick = (organisation, e) => {
        e.preventDefault();
        e.stopPropagation();
        if (this.props.onToggleFavourite) {
            this.props.onToggleFavourite(organisation);
        }
    };

    render() {
        const { t } = this.props;
        const childProps = this.props.childProps;
        const isSuperAdmin = childProps && childProps.userIsAuthorized
            ? childProps.userIsAuthorized(childProps.user, ['staff_super_admin'])
            : false;

        let organisationRows = this.props.organisations.map(
            (organisation, index) => {
                const isFavourited = this.isFavourited(organisation);
                return (
                    <tr key={index}>
                        {isSuperAdmin ? (
                            <td align="center" width="50" style={{padding: '8px'}}>
                                <i
                                    className={isFavourited ? 'fas fa-star favourite-star' : 'far fa-star favourite-star'}
                                    onClick={(e) => this.handleStarClick(organisation, e)}
                                    title={
                                        isFavourited
                                            ? t('OrganisationTable.removeFromFavourites')
                                            : t('OrganisationTable.addToFavourites')
                                    }
                                    style={{fontSize: '18px'}}
                                />
                            </td>
                        ) : null}
                        <td className="hidden-xs">
                            <span className="label label-success">
                                {t('OrganisationTable.active')}
                            </span>
                        </td>
                        <td>
                            <TooltipLink
                                to="#"
                                style={{
                                    alignItems: "center",
                                    textAlign: "left"
                                }}  
                                className={"label label-" +  (organisation.planType === 'PREMIUM' ? 'primary' : 'default')}
                                tooltip={(organisation.planType === 'PREMIUM' ?  t(
                                    'OrganisationTable.premium'
                                ) :  t(
                                    'OrganisationTable.lite'
                                ))}
                                onClick={() =>
                                    this.handleChangeOrganisation(organisation)
                                }
                            >
                                {organisation.name}
                                </TooltipLink>
                        </td>
                        <td className="hidden-xs  hidden-sm">
                            {organisation.email}
                        </td>
                        <td className="hidden-xs  hidden-sm">
                            {organisation.phone}
                        </td>
                        <td className="hidden-xs">
                            {Moment(organisation.updatedAt).format(
                                'YYYY-MM-DD HH:mm'
                            )}
                        </td>
                        <td>
                            {Moment(organisation.createdAt).format(
                                'YYYY-MM-DD HH:mm'
                            )}
                        </td>
                        <td align="center" width="150">
                           
                          <div className="btn-group pull-right">
                             <TooltipLink
                                id="editButton"
                                className="btn btn-default"
                                tooltip={t(
                                    'OrganisationTable.editorganisation'
                                )}
                                to={
                                    '/organisations/' +
                                    organisation.uuid +
                                    '/edit'
                                }
                            >
                                <em className="fas fa-pencil-alt" />
                            </TooltipLink>
                            <TooltipButton
                                id="deactivateButton"
                                className="btn-warning"
                                tooltip={t('OrganisationTable.deactivateorganisation')}
                                onClick={() => this.handleDeactivateClicked(organisation)}
                            >
                                <em className="fa fa-ban" />
                            </TooltipButton>
                            <TooltipButton
                                id="deleteButton"
                                className="btn-danger"
                                tooltip={t('OrganisationTable.deleteorganisation')}
                                onClick={() => this.handleDeleteClicked(organisation)}
                            >
                                <em className="fa fa-trash" />
                            </TooltipButton>
                        </div>
                            
                        </td>
                    </tr>
                );
            }
        );

        return (
            <div id="organisations">
                <Dialog
                    ref={el => {
                        this.dialog = el;
                    }}
                />
                <Table striped bordered condensed hover>
                    <thead>
                        <tr>
                            {isSuperAdmin && (
                                <th align="center" width="50">
                                    <i className="fa fa-star" />
                                </th>
                            )}
                            <th className="hidden-xs">
                                {t('OrganisationTable.status')}
                            </th>
                            <th>{t('OrganisationTable.name')}</th>
                            <th className="hidden-xs hidden-sm">
                                {t('OrganisationTable.email')}
                            </th>
                            <th className="hidden-xs hidden-sm">
                                {t('OrganisationTable.phone')}
                            </th>
                            <th className="hidden-xs">
                                {t('OrganisationTable.updated')}
                            </th>
                            <th>{t('OrganisationTable.created')}</th>
                            <th width="500">
                                <em className="fa fa-cog" />
                            </th>
                        </tr>
                    </thead>
                    <tbody>{organisationRows}</tbody>
                </Table>
            </div>
        );
    }
}

export default translate('translations')(withRouter(OrganisationTable));
